import { render, staticRenderFns } from "./ExamEditorTable.vue?vue&type=template&id=72cdf2d6"
import script from "./ExamEditorTable.vue?vue&type=script&lang=js"
export * from "./ExamEditorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports